import highlights from '@/mixins/search/highlights'

export default {
  mixins: [highlights],
  props: {
    highlights: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    highlightsLoading: {
      type: Boolean,
      required: true
    },
    link: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
    }
  },
  computed: {
    country () {
      if (!this.isEmpty(this.data.locations)) return this.data.locations[0].country
      if (!this.isEmpty(this.data.geography)) return this.data.geography[0].country
      if (!this.isEmpty(this.data.organisations)) return this.data.organisations[0].country
    },
    locationString () {
      if (this.isEmpty(this.data.locations)) return ''

      const locationStringArray = this.data.locations.map(location => {
        const locationSections = []
        if (location.city) locationSections.push(location.city)
        if (location.us_state) {
          // Split us_state string into full name and code (e.g. Texas, TX =. ['Texas', 'TX'])
          const stateSections = location.us_state.split(', ')
          // We're only interested in the state code
          locationSections.push(stateSections[stateSections.length - 1])
        }
        if (location.country) locationSections.push(location.country.name)

        return locationSections.join(', ')
      })

      return locationStringArray.join(' and ')
    },
    title () {
      return this.highlights && this.highlights.title ? this.highlights.title[0] : this.data.title
    },
    summary () {
      if (this.data.text) {
        if (this.highlights && this.highlights.text) {
          return this.stripTagsNoMark(this.highlights.text[0])
        } else {
          return this.stripTags(this.data.text)
        }
      }
      return ''
    },
    publicationDate () {
      if (this.data.publication_date) {
        return this.$options.filters.formatDate(this.data.publication_date, 'MMMM D, YYYY')
      }
      return ''
    },
    publicationDateFromNow () {
      if (this.data.publication_date) {
        return this.$options.filters.fromNow(this.data.publication_date)
      }
      return ''
    }
  }
}
